import React from 'react';
import type { ConsentProfile } from 'types/nhis';
import { DetailContainer, DetailTitle, DetailTable, DetailRow, DetailLabel, DetailValue } from './styles';

/** 동의 3: 민감정보 수집 및 이용 동의 (CONSENT_VERSION 20260423) */
const ConsentDetail3: React.FC<{ profile?: ConsentProfile }> = ({ profile }) => (
  <DetailContainer>
    <DetailTitle $kmrs={profile === 'kmrs'}>민감정보 수집 및 이용 동의</DetailTitle>
    <DetailTable>
      <tbody>
        <DetailRow>
          <DetailLabel>수집 및 이용 목적</DetailLabel>
          <DetailValue>
            <ul>
              <li>과거 투약 이력을 바탕으로 한 <strong>약 20여 가지 이상의 다각적 약물학적 기준 사전 검토</strong></li>
              <li>담당 약사가 전문적인 심층 검토를 수행할 수 있도록 돕는 <strong>보조 분석 자료 생성</strong></li>
            </ul>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>수집하는 항목</DetailLabel>
          <DetailValue>
            <strong>건강보험심사평가원('내가 먹는 약 한눈에' 서비스 등) 조회 대행을 통해 불러온 데이터 중 환자가 선택한 항목</strong>
            <ul>
              <li>진료/처방일자, 처방약품명, 약품코드</li>
              <li>의료기관/약국명, 진료형태, 방문일수</li>
              <li>처방횟수, 1회 투약량, 1일 투약횟수, 총 투약일수</li>
              <li>성별, 생년</li>
            </ul>
            <p className="note">
              ※ 수집된 원본은 담당 약사 상담에 사용되며, 동의4의 AI 분석 시점에만 가명처리되어 활용됩니다.
            </p>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>보유 및 이용 기간</DetailLabel>
          <DetailValue>
            <strong>동의일로부터 5년</strong>
            <p className="note">
              ※ 사유: 담당 약사가 환자분에게 지속적이고 일관된 약물 관리를 수행할 수 있도록 당사 서버에서 해당 기간 보관합니다.
            </p>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>동의 거부 권리 및 불이익</DetailLabel>
          <DetailValue>
            귀하는 민감정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다.
            <p className="note">
              ※ 단, 귀하의 투약 이력은 약물 부작용 방지 및 심층 검토를 위한 핵심 필수 정보이므로, 거부 시 본 서비스를 이용하실 수 없습니다.
            </p>
          </DetailValue>
        </DetailRow>
      </tbody>
    </DetailTable>
  </DetailContainer>
);

export default ConsentDetail3;
